import { Box, Grid, Hidden, Typography } from "@material-ui/core";

export default function RequestHeader() {
  return (
    <Box mx="1.5rem" mb="1rem">
      <Grid container>
        <Hidden smDown>
          <Grid item md={2} sm={3} xs={6}>
            <Typography variant="subtitle2" color="textSecondary">
              Transaction ID
            </Typography>
          </Grid>
        </Hidden>
        <Grid item md={5} xs={9}>
          <Typography variant="subtitle2" color="textSecondary">
            Request Data
          </Typography>
        </Grid>
        <Grid item md={2} sm={3} xs={2}>
          <Typography variant="subtitle2" color="textSecondary">
            Status
          </Typography>
        </Grid>
        <Hidden xsDown>
          <Grid item md={2} sm={3}>
            <Typography variant="subtitle2" color="textSecondary">
              Action
            </Typography>
          </Grid>
        </Hidden>
        <Hidden smDown>
          <Grid item md={1}></Grid>
        </Hidden>
      </Grid>
    </Box>
  );
}
